import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { format } from 'date-fns'
import { Calendar, Link2, Users } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { RecruitingCampaign } from '@/api-client'

export function Recruiting() {
  // const { data, error } = useAppSWR<{ campaigns: RecruitingCampaign[] }>('/recruiting-campaigns')

  // if (error) {
  //   return <div className="p-4 text-red-500">Error loading campaigns: {error.message}</div>
  // }

  // if (!data) {
  //   return <div className="p-4 text-gray-500">Loading campaigns...</div>
  // }

  // return (
  //   <div className="p-6 space-y-6">
  //     <div className="flex justify-between items-center">
  //       <h1 className="text-2xl font-semibold">Recruiting Campaigns</h1>
  //       <Button>Create Campaign</Button>
  //     </div>

  //     <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
  //       <Table>
  //         <TableHeader>
  //           <TableRow>
  //             <TableHead>Name</TableHead>
  //             <TableHead>Period</TableHead>
  //             <TableHead>Total Invites</TableHead>
  //             <TableHead>Criteria</TableHead>
  //             <TableHead>Link</TableHead>
  //             <TableHead>Created</TableHead>
  //             <TableHead>Actions</TableHead>
  //           </TableRow>
  //         </TableHeader>
  //         <TableBody>
  //           {data.campaigns.map((campaign) => (
  //             <TableRow key={campaign.id} className="group hover:bg-gray-50 transition-colors">
  //               <TableCell className="font-medium">{campaign.name}</TableCell>
  //               <TableCell>
  //                 <div className="flex items-center gap-2">
  //                   <Calendar size={16} className="text-gray-500" />
  //                   <span>
  //                     {format(new Date(campaign.start_date), 'MMM d, yyyy')} -{' '}
  //                     {format(new Date(campaign.end_date), 'MMM d, yyyy')}
  //                   </span>
  //                 </div>
  //               </TableCell>
  //               <TableCell>
  //                 <div className="flex items-center gap-2">
  //                   <Users size={16} className="text-gray-500" />
  //                   <span>{campaign.total_invites}</span>
  //                 </div>
  //               </TableCell>
  //               <TableCell>
  //                 <div className="flex gap-2 flex-wrap">
  //                   {campaign.criteria.map((criterion, index) => (
  //                     <Badge key={index} variant="secondary">
  //                       {criterion.property} {criterion.operator} {criterion.value}
  //                     </Badge>
  //                   ))}
  //                 </div>
  //               </TableCell>
  //               <TableCell>
  //                 <div className="flex items-center gap-2">
  //                   <Link2 size={16} className="text-gray-500" />
  //                   <a
  //                     href={campaign.link}
  //                     target="_blank"
  //                     rel="noopener noreferrer"
  //                     className="text-blue-600 hover:underline"
  //                   >
  //                     View Link
  //                   </a>
  //                 </div>
  //               </TableCell>
  //               <TableCell>{format(new Date(campaign.created_at), 'MMM d, yyyy')}</TableCell>
  //               <TableCell>
  //                 <div className="flex gap-2 invisible group-hover:visible">
  //                   <Button size="sm" variant="ghost" className="h-8 w-8 p-0">
  //                     <span className="sr-only">Edit</span>
  //                     <svg
  //                       className="h-4 w-4 text-gray-500"
  //                       xmlns="http://www.w3.org/2000/svg"
  //                       fill="none"
  //                       viewBox="0 0 24 24"
  //                       stroke="currentColor"
  //                     >
  //                       <path
  //                         strokeLinecap="round"
  //                         strokeLinejoin="round"
  //                         strokeWidth={2}
  //                         d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
  //                       />
  //                     </svg>
  //                   </Button>
  //                   <Button size="sm" variant="ghost" className="h-8 w-8 p-0">
  //                     <span className="sr-only">Delete</span>
  //                     <svg
  //                       className="h-4 w-4 text-gray-500"
  //                       xmlns="http://www.w3.org/2000/svg"
  //                       fill="none"
  //                       viewBox="0 0 24 24"
  //                       stroke="currentColor"
  //                     >
  //                       <path
  //                         strokeLinecap="round"
  //                         strokeLinejoin="round"
  //                         strokeWidth={2}
  //                         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  //                       />
  //                     </svg>
  //                   </Button>
  //                 </div>
  //               </TableCell>
  //             </TableRow>
  //           ))}
  //         </TableBody>
  //       </Table>
  //     </div>
  //   </div>
  // )

  return <div>Recruiting</div>
}
